import React from 'react';
import CrudLayoutContainer from 'src/components/crud-layout-component/CrudLayoutContainer';
import { UnAuthorizedErrorPage } from 'src/utils/CommonUtils';
import RoutingUtil from 'src/utils/RoutingUtil';
import SearchContainerWithPermission from '../search-container/SearchContainerWithPermission';
import { productEditAction, productSearchAction } from './actions/ProductActions';
import ProductForm from './ProductForm';

const tabs = [
    {
        title: 'Manage',
        link: RoutingUtil.productManagerUrl(),
    },
    {
        title: 'Search',
        link: RoutingUtil.productSearch(),
    },
];

const routes = [
    {
        link: RoutingUtil.productManagerUrl(),
        component: ProductForm,
    },
    {
        link: RoutingUtil.productSearch(),
        component: () => (
            <SearchContainerWithPermission
                scope="master.product_manager.search"
                editScope="master.product_manager.search.edit"
                fallback={<UnAuthorizedErrorPage />}
                queryParamsAsWhere
                reducer="ProductReducer"
                dataPath="search"
                editAction={productEditAction}
                redirectUrlOnEdit={RoutingUtil.productManagerUrl()}
                action={productSearchAction}
                caseSensitiveSearchProperties={[
                    'category',
                ]}
                columns={{
                    productName: {
                        display: 'Product Name',
                    },
                    active: {
                        display: 'Active',
                    },
                    category: {
                        display: 'Category',
                    },
                    by: {
                        display: 'By',
                        path: 'by.personalInfo.firstName',
                    },
                    updatedBy: {
                        display: 'Updated By',
                        path: 'updatedBy.personalInfo.firstName',
                    },
                    ts: {
                        display: 'Ts',
                        type: Date,
                    },
                    updatedTs: {
                        display: 'Updated Ts',
                        type: Date,
                    },
                }}
            />
        ),
    },
];

const ProductContainer = () => (
    <CrudLayoutContainer
        title="Product Manager"
        tabs={tabs}
        routes={routes}
    />
);

ProductContainer.propTypes = {

};

export default ProductContainer;
